import {AfterViewInit, Component, OnInit} from '@angular/core';
import { AuthenticationService } from '../providers/authentication.service';
import {NavigationEnd, Router} from '@angular/router';
declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  public menu: string;
  constructor(public auth: AuthenticationService,
              public router: Router) {
    if (this.auth.auth_data === 'loged') {
      this.menu = 'loged';
    } else {
      this.menu = 'unloged';
    }
  }

  ngAfterViewInit() {
    this.router.events.subscribe((evt) => {
      if (typeof ($('.homepage'))) {
        $('footer').addClass('nomargin');
      } else {
        $('footer').removeClass('nomargin');
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/app/app.component.ts